import {
    ITextScaleObserverController,
    TextScaleElement,
    TextScaleManagerObserversCallback,
    TextScaleObserverElement,
} from '@/scripts/_common/text-scale/text-scale.types';

class TextScaleManagerObservers {
    public storageObservers = new Map<ITextScaleObserverController, TextScaleElement[]>();
    public storageActives = new Set<ITextScaleObserverController>();
    private observer?: ResizeObserver;
    public onResize: TextScaleManagerObserversCallback | undefined;

    constructor(onResize?: TextScaleManagerObserversCallback) {
        this.onResize = onResize;
    }

    getObserverByElement(element: TextScaleObserverElement) {
        for (const key of this.storageObservers.keys()) {
            if (key.element === element) {
                return key;
            }
        }
        return undefined;
    }

    // Элемент ResizeObserver — либо сам контейнер-наблюдатель, либо его контейнер-лимит.
    // Лимит отслеживаем отдельно: его размер может измениться без изменения наблюдателя
    // (например, в слайде карусели догрузилась картинка вместо заглушки 1×1).
    getObserversByTarget(target: HTMLElement) {
        const result: ITextScaleObserverController[] = [];
        for (const key of this.storageObservers.keys()) {
            if (key.element === target || key.textScaleLimit.element === target) {
                result.push(key);
            }
        }
        return result;
    }

    private getObserver() {
        if (this.observer) {
            return this.observer;
        }

        this.observer = new ResizeObserver((entries) => {
            requestAnimationFrame(() => {
                let elementsList: TextScaleElement[] | undefined;
                const processed = new Set<ITextScaleObserverController>();

                for (const entry of entries) {
                    if (!entry.contentBoxSize) {
                        continue;
                    }

                    for (const keyStorageObserver of this.getObserversByTarget(entry.target as HTMLElement)) {
                        elementsList = this.storageObservers.get(keyStorageObserver);
                        if (typeof elementsList === 'undefined' || this.storageActives.has(keyStorageObserver) || processed.has(keyStorageObserver)) {
                            continue;
                        }
                        processed.add(keyStorageObserver);
                        this.storageActives.add(keyStorageObserver);

                        if (this.onResize) {
                            this.onResize(elementsList, keyStorageObserver.textScaleLimit, keyStorageObserver);
                            this.storageActives.delete(keyStorageObserver);
                        }
                    }
                }
            });
        });

        return this.observer;
    }

    observe(containerObserver: ITextScaleObserverController) {
        if (!containerObserver.isRegistered) {
            this.getObserver().observe(containerObserver.element);
            this.getObserver().observe(containerObserver.textScaleLimit.element);
            containerObserver.isRegistered = true;
        }
    }

    unobserve(containerObserver: ITextScaleObserverController) {
        this.storageObservers.delete(containerObserver);
        this.getObserver().unobserve(containerObserver.element);

        const limitElement = containerObserver.textScaleLimit.element;
        const isLimitShared = Array.from(this.storageObservers.keys()).some((key) => key.isRegistered && key.textScaleLimit.element === limitElement);
        if (!isLimitShared) {
            this.getObserver().unobserve(limitElement);
        }

        containerObserver.isRegistered = false;
    }
}

export default TextScaleManagerObservers;
